import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { SpazioPerTe } from "@/components/SpazioPerTe";
import { Dottore } from "@/components/Dottore";
import { Approccio } from "@/components/Approccio";
import { QuandoUtile } from "@/components/QuandoUtile";
import { Recensioni } from "@/components/Recensioni";
import { Libro } from "@/components/Libro";
import { RiflessioniPreview } from "@/components/RiflessioniPreview";
import { Percorso } from "@/components/Percorso";
import { CtaEmozionale } from "@/components/CtaEmozionale";
import { Contatti } from "@/components/Contatti";
import { Newsletter } from "@/components/Newsletter";
import { Footer } from "@/components/Footer";
import { WhatsAppButton } from "@/components/WhatsAppButton";

export default function Home() {
    return (
        <div className="bg-cream" data-testid="home-page">
            <Navbar />
            <main>
                <Hero />
                <Marquee />
                <SpazioPerTe />
                <Dottore />
                <Approccio />
                <QuandoUtile />
                <Recensioni />
                <Libro />
                <RiflessioniPreview />
                <Percorso />
                <CtaEmozionale />
                <Contatti />
                <Newsletter />
            </main>
            <Footer />
            <WhatsAppButton />
        </div>
    );
}
